/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // ── Mobile size dropdown toggle ──
  document.addEventListener('click', function(e) {
    var container = e.target.closest('.radio__buttons');
    if (!container) {
      // clicked outside — close all open dropdowns
      document.querySelectorAll('.radio__buttons.is-open').forEach(function(el) {
        el.classList.remove('is-open');
      });
      return;
    }

    // only act on size picker containers (not color swatches)
    if (!container.querySelector('.radio__button')) return;

    var isOpen = container.classList.contains('is-open');

    // close any other open dropdowns first
    document.querySelectorAll('.radio__buttons.is-open').forEach(function(el) {
      el.classList.remove('is-open');
    });

    if (!isOpen) {
      container.classList.add('is-open');
    }

    // if a size was selected, close the dropdown
    if (e.target.closest('label')) {
      container.classList.remove('is-open');
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


// ── Pre-order pricing badge swap ──
document.addEventListener('DOMContentLoaded', function () {
  function swapFinalSaleBadge() {
    const isPreorder = document.querySelector('.badge-box.preorder-box') !== null;
    if (!isPreorder) return;

    document.querySelectorAll('.product__final-sale').forEach(el => {
      if (el.innerText.trim() === 'Final sale') {
        el.innerText = 'Pre-order pricing';
      }
    });
  }

  // Run on load
  swapFinalSaleBadge();

  // Watch the exact container Broadcast re-renders on variant change
  const priceContainer = document.querySelector('.product__sale[data-price-off]');
  if (priceContainer) {
    const observer = new MutationObserver(swapFinalSaleBadge);
    observer.observe(priceContainer, { childList: true, subtree: true });
  }
});


// ── Fix Redo app adding phantom padding-top on product pages ──
if (document.body.classList.contains('template-product')) {
  const removeBodyPadding = () => {
    document.body.style.paddingTop = '0px';
  };

  removeBodyPadding();

  const observer = new MutationObserver(removeBodyPadding);
  observer.observe(document.body, { attributes: true, attributeFilter: ['style'] });
}